module.exports = __webpack_public_path__ + "16169e41e71d58648b8d4612f2c8fd70.pdf";